import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useServicesContext } from '../../contexts/ServicesContext';
import { mapI18nLanguageToApiLanguage } from './language.mapper';

export const GetSurveyByUUIDQueryKey = 'GET_SURVEY_BY_UUID';

export const useGetSurveyByUUIDQuery = (
  uuid: string,
  { enabled }: { enabled: boolean },
) => {
  const { fetchSurveyByUUID } = useServicesContext();
  const { i18n } = useTranslation();

  const apiLanguage = mapI18nLanguageToApiLanguage(i18n.language);

  return useQuery({
    queryKey: [GetSurveyByUUIDQueryKey, uuid, apiLanguage],
    queryFn: () => fetchSurveyByUUID(uuid, apiLanguage),
    enabled,
  });
};
